import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotLoggedIn = (props) => /* @__PURE__ */ _jsx("svg", {
	height: "1em",
	viewBox: "0 0 141 180",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#000",
		strokeWidth: 4,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m23 79.156h60.255v24.878c0 16.863-13.42 30.408-30.127 30.408s-30.128-13.545-30.128-30.408z" }),
			/* @__PURE__ */ _jsx("path", { d: "m53.128 133.668v19.395c0 13.854 10.984 24.937 24.714 24.937s24.714-11.083 24.714-24.937v-22.165c0-13.854 10.984-24.937 24.714-24.937h13.73m-101.262-26.805v-30.156m26.78 30.156v-30.156" }),
			/* @__PURE__ */ _jsx("path", { d: "m81.004 28.48 8.896 8.582m6.2 6.388 8.896 8.582m0-23.552-8.896 8.582m-6.2 5.983-8.896 8.582" }),
			/* @__PURE__ */ _jsx("path", { d: "m41.004 1.48 8.896 8.582m6.2 6.388 8.896 8.582m0-23.552-8.896 8.582m-6.2 5.983-8.896 8.582" }),
			/* @__PURE__ */ _jsx("path", { d: "m2.004 28.48 8.896 8.582m6.2 6.388 8.896 8.582m0-23.552-8.896 8.582m-6.2 5.983-8.896 8.582" })
		]
	})
});
export default SvgNotLoggedIn;
